@if (!labels || labels.length===0) {
    <p class="empty">There is no data to show.</p>
}@else {
    <div [style]="getStyle()">
        <canvas id="chart" baseChart
            [type]="'bar'"
            [datasets]="values"
            [labels]="labels"
            (chartClick)="onSelect($event)"
            [options]="chartOptions"
            [plugins]="chartPlugins"
            [legend]="!hideLegend">
        </canvas>
    </div>
}

